module.exports = __webpack_public_path__ + "img/investment.6a2af5e0.png";